import { Component } from '@angular/core';

@Component({
    selector: 'nio-digital-workspace-sundown-isd-and-netsync',
    templateUrl: './digital-workspace-sundown-isd-and-netsync.component.html',
    styleUrls: ['./digital-workspace-sundown-isd-and-netsync.component.scss'],
    standalone: false
})
export class DigitalWorkspaceSundownISDAndNetsyncComponent {}
